'use strict';

import {
    addButtonStyling,
    addCellColorStyles,
    highlightCells,
    highlightCellsPdf,
    highlightCellsPrint,
} from "../jquery-functions-library";

export function addExportBtns(table, amountCol) {
    new $.fn.dataTable.Buttons(table.DataTable(), {
            buttons: getDtButtons(amountCol)
        }
    );
    addButtonStyling(table.DataTable());
}

function getDtButtons(amountCol) {
    return [
        {
            extend: "excelHtml5",
            footer: true,
            //this overwrites the standard styling for footer cells in buttons.html5.js which sets the row to have a styling of only bold.
            customize: function (xlsx) {
                var styleSheet = xlsx.xl['styles.xml'];
                var lastXfIndex = $('cellXfs xf', styleSheet).length - 1;
                //custom styling: Right alignment, bold, two decimal places.
                var numberFormatTwoDecimalBold = '<xf numFmtId="4" fontId="2" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
                '<alignment horizontal="right"/></xf>'
                //custom styling: Right alignment, two decimals for numbers with thousandsseparator
                var numberFormatRightAlignedThousandsSeparator = '<xf numFmtId="4" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
                '<alignment horizontal="right"/></xf>'
                styleSheet.childNodes[0].childNodes[5].innerHTML += numberFormatTwoDecimalBold + numberFormatRightAlignedThousandsSeparator;
                var twoDecPlacesBold = lastXfIndex + 1;
                var thousandsSeparatorRightAligned = lastXfIndex + 2;
                var sheet = xlsx.xl.worksheets['sheet1.xml'];
                var rows = $('row', sheet); //get all rows
                //iterate over all rows except last row (last row is the footer row) and apply custom styling to the cells
                for (var i = 0; i < rows.length - 1; i++) {
                    $('row:eq(' + i + ') c', sheet).attr('s', thousandsSeparatorRightAligned);
                }

                //Make id and voucher number columns styled as text
                $('row c[r^="A"]', sheet).attr('s', 0);
                $('row c[r^="C"]', sheet).attr('s', 0);

                //Make header row bold
                $('row:eq(1) c', sheet).attr('s', twoDecPlacesBold);
                //apply custom styling to the footer row 
                $('row:last c', sheet).attr('s', twoDecPlacesBold); 

                let styles = xlsx.xl['styles.xml'];
                let stylesCount = parseInt($( 'cellXfs', styles ).attr("count"), 10);
                addCellColorStyles(styles, stylesCount);

                // use new styles:
                highlightCells(sheet, stylesCount);

            },
            exportOptions: {
                columns: [
                    ':not(.not-export)', //ensures the column 'Actions' is not included in export.
                ], 
                format: {
                    body: function (data, row, column, node) {
                        data = $('<p>' + data + '</p>').text();
                        if (column === amountCol) {
                            data = data.replace('.', '');
                            
                            return data.replace(',', '.');
                        }

                        return data.trim();
                    },
                    footer: function(data, row, column, node) {
                        data = $('<p>' + data + '</p>').text();
                        if (column === amountCol) {
                            data = data.replace('.', '');

                            return data.replace(',', '.');
                        }

                        return data.trim();
                    },
                }, 
            },  
        },
        {
            extend: "pdf",
            orientation: "landscape",
            pageSize: "LEGAL",
            footer: true,
            exportOptions: {
                columns: ':not(.not-export)', //ensures the column 'Actions' is not included in export.
            },
            customize: function(doc) {
                highlightCellsPdf(doc);
            }
        },
        {
            extend: "csv",
            footer: true,
            exportOptions: {
                columns: ':not(.not-export)', //ensures the column 'Actions' is not included in export.
            },
        },
        {
            extend: "copy",
            footer: true,
            exportOptions: {
            columns: ":visible",
            },
        },
        {
            extend: "print",
            footer: true,
            exportOptions: {
            columns: ":visible",
            },
            customize: function(win) {            
                highlightCellsPrint(win);
            }
        },
    ];
}